<template>
  <div class="mb-4 pt-2">
    <div class="liderki-boxes mb-3">
      <div class="liderki-boxes__box kreatywna-druzynowa">
        <h4 class="liderki-boxes__box-title">Kreatywna<br/>drużynowa</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s1-kreatywna-druzynowa.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Nie pozwalaj na nudę</div>
            <div>Wspieraj jej pasje</div>
            <div>Dawaj wciągać się w zabawę</div>
            <div>Nie ograniczaj jej w posiadaniu własnego „stada”</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box niezrownana-zwyciezczyni">
        <h4 class="liderki-boxes__box-title">Niezrównana<br/>zwyciężczyni</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s2-niezrownana-zwyciezczyni.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Rozmawiaj, dyskutuj, słuchaj co ma Ci do powiedzenia</div>
            <div>Pozwalaj jej przewodzić na polach jej kompetencji</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box kreatorka-rozwiazan">
        <h4 class="liderki-boxes__box-title">Kreatorka<br/>rozwiązań</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s3-kreatorka-rozwiazan.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Wysłuchaj jej ekspertyz</div>
            <div>Bądź też w czymś najlepszy/a – aby jej zaimponować</div>
            <div>Pokaż jej uroki spontaniczności</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box kanapowa-menadzerka">
        <h4 class="liderki-boxes__box-title">Kanapowa<br/>menadżerka</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s4-kanapowa-menadzerka.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Doceniaj jej umiejętność planowania</div>
            <div>Słuchaj jej rad, ale też z nimi dyskutuj</div>
            <div>Nie bierz wszystkiego na swoje barki</div>
          </div>
        </div>
      </div>

      <div class="liderki-boxes__box realizujaca-marzenia">
        <h4 class="liderki-boxes__box-title">Realizująca<br/>marzenia</h4>

        <div class="box-content">
          <div class="liderki-boxes__box-image">
            <img :src="require('@/assets/images/pic-s5-realizujaca-marzenia.png')"
                 alt="Segment image"
            />
          </div>

          <div class="text">
            <div>Pozwól jej na realizację marzeń</div>
            <div>Wspieraj jej sieć przyjaciółek</div>
            <div>Daj jej przestrzeń do działania</div>
            <div>Chwal!</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Start3',
  props: ['quiz', 'numStartPage'],
};
</script>
